<script setup>
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters, useStore } from 'dashboard/composables/store';

import CampaignMetricCard from './CampaignMetricCard.vue';

const props = defineProps({
  campaign: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();
const getters = useStoreGetters();

const campaignReport = getters['wgptReports/campaignReport'];
const uiFlags = getters['wgptReports/getUIFlags'];

const isLoading = computed(() => uiFlags.value.isFetchingCampaignReport);

const fetchReport = async campaignId => {
  store.dispatch('wgptReports/getCampaign', campaignId);
};

watch(
  () => props.campaign,
  ({ id }) => {
    fetchReport(id);
  },
  { immediate: true }
);
</script>

<template>
  <div
    class="mx-0 shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2 px-6 py-5"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <CampaignMetricCard
        :label="t('WGPT_CAMPAIGNS.REPORTS.METRICS.SENT.LABEL')"
        :value="campaignReport.total_messages_sent"
        :info-text="t('WGPT_CAMPAIGNS.REPORTS.METRICS.SENT.INFO')"
        :is-loading="isLoading"
      />

      <CampaignMetricCard
        :label="t('WGPT_CAMPAIGNS.REPORTS.METRICS.DELIVERED.LABEL')"
        :value="campaignReport.total_delivered"
        :info-text="t('WGPT_CAMPAIGNS.REPORTS.METRICS.DELIVERED.INFO')"
        :is-loading="isLoading"
      />
      <CampaignMetricCard
        :label="t('WGPT_CAMPAIGNS.REPORTS.METRICS.FAILED.LABEL')"
        :value="campaignReport.total_failed_messages"
        :info-text="t('WGPT_CAMPAIGNS.REPORTS.METRICS.FAILED.INFO')"
        :is-loading="isLoading"
      />
      <CampaignMetricCard
        :label="t('WGPT_CAMPAIGNS.REPORTS.METRICS.READ.LABEL')"
        :value="campaignReport.total_read"
        :info-text="t('WGPT_CAMPAIGNS.REPORTS.METRICS.READ.INFO')"
        :is-loading="isLoading"
      />
      <CampaignMetricCard
        :label="t('WGPT_CAMPAIGNS.REPORTS.METRICS.NO_WHATSAPP.LABEL')"
        :value="campaignReport.total_recipients_without_whatsapp"
        :info-text="t('WGPT_CAMPAIGNS.REPORTS.METRICS.NO_WHATSAPP.INFO')"
        :is-loading="isLoading"
      />
      <CampaignMetricCard
        :label="t('WGPT_CAMPAIGNS.REPORTS.METRICS.REPLIES.LABEL')"
        :value="campaignReport.total_replies"
        :info-text="t('WGPT_CAMPAIGNS.REPORTS.METRICS.REPLIES.INFO')"
        :is-loading="isLoading"
      />
    </div>
  </div>
</template>
